import { marked } from "marked";
import { useEffect, useRef } from "react";

import Logo from "../images/iXie-logo.png";

import { quickReplies } from "../constants";
import type { ChatMessageProps } from "../types/types";

marked.use({
  renderer: {
    link(this: any, token: any) {
      const href = token.href ?? "";
      const text = token.text ?? "";
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  },
});

const renderMarkdown = (text: string): string => {
  return marked.parse(text) as string;
};

const ChatResponseContainer = ({
  messages,
  isLoading,
  onQuickReply,
}: ChatMessageProps) => {
  // Hooks
  const chatContainerRef = useRef<HTMLDivElement | null>(null);
  const lastUserRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (messages.length === 0) return;

    const container = chatContainerRef.current;
    const userMessage = lastUserRef.current;

    if (!container || !userMessage) return;

    const top = userMessage.offsetTop - container.offsetTop - 21;

    container.scrollTo({
      top,
      behavior: "smooth",
    });
  }, [messages]);

  // Handlers
  const buttonOnClickHandler = (text: string) => {
    if (onQuickReply) onQuickReply(text);
  };

  return (
    <div className="chat-response-container" ref={chatContainerRef}>
      <div className="bot-bubble-flex-container">
        <img src={Logo} alt="Sentral Logo" />
        <div className="bot-bubble-container">
          <p className="bot-message">
            Hi! Ako si iXie, your guide to iCXeed. Pwede ko kayong tulungan so
            you can understand what we do, how we work, and what it is really
            like to grow here. Saan mo gusto magsimula?
          </p>

          <div className="flexbox-button-chat">
            {quickReplies.map((reply, idx) => (
              <button
                key={idx}
                disabled={isLoading}
                style={{
                  cursor: isLoading ? "default" : "",
                }}
                onClick={() => buttonOnClickHandler(reply)}
                className="response-button-blk"
              >
                {reply}
              </button>
            ))}
          </div>
        </div>
      </div>

      {messages.map((m, i) => {
        const isLastUser =
          m.sender === "user" &&
          !messages.slice(i + 1).some((msg) => msg.sender === "user");

        if (m.sender === "user") {
          return (
            <div
              key={i}
              ref={isLastUser ? lastUserRef : null}
              className="bot-bubble-flex-container"
              style={{ justifyContent: "flex-end" }}
            >
              <div className="bot-bubble-container">
                <p className="user-message">{m.text}</p>
              </div>
            </div>
          );
        }

        return (
          <div key={i} className="bot-bubble-flex-container">
            <img src={Logo} alt="Sentral Logo" />
            <div className="bot-bubble-container">
              <div
                className="bot-message"
                dangerouslySetInnerHTML={{
                  __html: renderMarkdown(m.text || ""),
                }}
              />

              {/* Buttons */}
              {Array.isArray(m.buttons) && m.buttons.length > 0 && (
                <div className="flexbox-button-chat">
                  {m.buttons.map((btn, idx) => (
                    <button
                      key={idx}
                      disabled={isLoading}
                      style={{
                        cursor: isLoading ? "default" : "",
                      }}
                      onClick={() =>
                        buttonOnClickHandler(btn?.title || btn?.value)
                      }
                      className="response-button-blk"
                    >
                      {btn?.title || btn?.value || btn?.text}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ChatResponseContainer;
